module.exports = "https://cdn1.saucelabs.com/web-ui/images/assets/2838cdd55ab7c94d1401e33beba1b7d3.png";